import { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const formatDayLabel = (isoDate) => {
  if (!isoDate || typeof isoDate !== "string") return "";
  const parts = isoDate.split("-");
  return parts.length === 3 ? parts[2] : isoDate;
};

const BookingTrendsChart = ({ data }) => {
  const points = Array.isArray(data?.points) ? data.points : [];

  const categories = useMemo(() => points.map((point) => formatDayLabel(point?.date)), [points]);

  const series = useMemo(
    () => [
      {
        name: "Pending",
        data: points.map((point) => Number(point?.pending) || 0),
      },
      {
        name: "Confirmed",
        data: points.map((point) => Number(point?.confirmed) || 0),
      },
      {
        name: "Cancelled",
        data: points.map((point) => Number(point?.cancelled) || 0),
      },
      {
        name: "Completed",
        data: points.map((point) => Number(point?.completed) || 0),
      },
    ],
    [points]
  );

const normalAxisStyle = { fontWeight: 400 };

  const options = useMemo(
    () => ({
      chart: {
        type: "line",
        fontFamily: "inherit",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#F4B400", "#2D9CDB", "#EB5757", "#27AE60"],
      markers: {
        size: 3,
        hover: {
          size: 5,
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
      },
      xaxis: {
        categories,
        labels: {
          style: normalAxisStyle,
        },
        title: {
          text: "Day of Month",
          style: normalAxisStyle,
        },
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        labels: {
          style: normalAxisStyle,
        },
        title: {
          text: "No. of Bookings",
          style: normalAxisStyle,
        },
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      noData: {
        text: "No booking trend data available",
      },
    }),
    [categories]
  );

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title mb-0">Bookings Per Day by Status</h4>
      </div>
      <div className="card-body">
        <div className="line-chart-style bar-chart">
          <ReactApexChart options={options} series={series} type="line" height={360} />
        </div>
      </div>
    </div>
  );
};

export default BookingTrendsChart;
